import React, { useState, useEffect } from "react";
import { PageHeader, Row, Col, Select, Button, Spin, DatePicker, Form } from "antd";
import moment from "moment";
import RenderDahsboard from "./renderDashboard";
import { dashboardList, customFilter, dashboardSocial, dashboardSGQ, requiredProps } from "./../constants/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "./../action/index";
import { selectDataForFixedSelectList as selectFixeList } from "./../../fixed_list/actions/index";
import { ApplyDashboardFilter } from "./filters";

const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

const DashboardIndex = ({ form, selectFixeList, getData, inqueritoList }) => {
    const [dataDashboard, setDataDashboard] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingInquiry, setLoadingInquiry] = useState(false);
    const [isFetchedInquiry, setIsFetchedInquiry] = useState(false);
    const [filterDashboard, setFilterDashboard] = useState([]);
    const [selectedDashboard, setSelectedDashboard] = useState(null);

    const [loadingStablishment, setLoadingStablishment] = useState(false);
    const [establishmentList, setEstablishmentList] = useState([]);

    const [loadingOrganic, setLoadingOrganic] = useState(false);
    const [isFetchedOrganic, setIsFetchedOrganic] = useState(false);
    const [organicUnits, setOrganicUnits] = useState([]);

    const [clients, setClients] = useState([]);
    const [clientGroups, setClientGroups] = useState([]);

    const { getFieldDecorator } = form;

    useEffect(() => {
        if (establishmentList.length > 0) {
            return;
        }

        loadEstablishment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadEstablishment = async () => {
        setLoadingStablishment(true);

        const { result } = await actionCreators.execQuery({
            query: "estabelecimento_utilizador",
        });

        if (result) {
            setEstablishmentList(result);
        }
        setLoadingStablishment(false);
    };

    const handleChangeStablishment = (estabelecimentId) => {
        if (!filterDashboard.includes(customFilter.unidadeOrganica)) {
            if (isFetchedOrganic) {
                setIsFetchedOrganic(false);
            }
            return false;
        } else {
            form.setFields({
                organicUnit: { value: null },
            });
            loadOrganic(estabelecimentId);
        }

        // if (filterDashboard.includes(customFilter.cliente)) {
        //     loadClientes(estabelecimentId, "");
        // }

        if (filterDashboard.includes(customFilter.grupoCliente)) {
            form.setFields({
                grupo_cliente: "",
            });
            // loadClientGroups(estabelecimentId, "");
        }
    };

    const handleChangeOrganitUnit = (unidadeOrganicaId) => {
        const selectedStablishment = form.getFieldValue("stablishment");
        if (filterDashboard.includes(customFilter.cliente)) {
            loadClientes(selectedStablishment, unidadeOrganicaId);
        }

        if (filterDashboard.includes(customFilter.grupoCliente)) {
            form.setFields({
                grupo_cliente: "",
            });
            loadClientGroups(selectedStablishment, unidadeOrganicaId);
        }
    };

    const handleChangeClientGroups = (groupId) => {
        const selectedStablishment = form.getFieldValue("stablishment");
        const selectedUnidadeOrganica = form.getFieldValue("organicUnit");
        if (filterDashboard.includes(customFilter.cliente)) {
            loadClientes(selectedStablishment, selectedUnidadeOrganica, groupId);
        }
    };

    const search = (e) => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                setLoadingData(true);
                const metadata = dashboardList.find((it) => it.key === values.dashboard);
                // values.dashboard = metadata.key;
                getData(values).then((response) => {
                    setDataDashboard({
                        metadata: metadata,
                        data: response || null,
                    });
                    setLoadingData(false);
                });
            }
        });
    };

    const loadInquiry = () => {
        let mounted = true;
        setLoadingInquiry(true);
        selectFixeList({ query: "rel_lista_tipo_inquerito" }, "rel_lista_tipo_inquerito").then(() => {
            if (mounted) {
                setLoadingInquiry(false);
                setIsFetchedInquiry(true);
            }
        });
    };

    const loadOrganic = async (estabelecimentId) => {
        setLoadingOrganic(true);
        const { result } = await actionCreators.execQuery({
            query: "valencias_actuais",
            idEstabelecimento: estabelecimentId,
        });

        if (result) {
            setOrganicUnits(result);
            setLoadingOrganic(false);
            setIsFetchedOrganic(true);
        }
    };

    const loadClientGroups = async (estabelecimentId, unidadeOrganicaId) => {
        if (!unidadeOrganicaId) {
            return;
        }

        const { result } = await actionCreators.execQuery({
            query: "scl_grupo_clientes",
            idEstabelecimento: estabelecimentId,
            valencia: unidadeOrganicaId,
        });

        if (result) {
            setClientGroups(result);
        }
    };

    const loadClientes = async (estabelecimentId, unidadeOrganicaId, groupId = "") => {
        if (!unidadeOrganicaId) {
            return;
        }

        const { result } = await actionCreators.execQuery({
            query: "scl_clientes",
            idEstabelecimento: estabelecimentId,
            valencia: unidadeOrganicaId,
            grupo_cliente: groupId,
        });

        if (result) {
            setClients(result);
        }
    };

    const handleChangeDashboard = async (e) => {
        let filters = [];
        let _selectedDashboard = null;

        if (e) {
            _selectedDashboard = dashboardList.find((it) => it.key === e);
            filters = _selectedDashboard && _selectedDashboard.filter ? _selectedDashboard.filter : [];
        }

        setFilterDashboard(filters);
        setSelectedDashboard(_selectedDashboard);

        if (_selectedDashboard.required?.includes(requiredProps.date)) {
            // for scl_registo_de_cuidados_individual
            form.setFields({
                date: { value: [moment(), moment()] },
            });
        }

        if (filters.includes(customFilter.unidadeOrganica) && !isFetchedOrganic) {
            // load organic
            const selectedStablishment = form.getFieldValue("stablishment");
            loadOrganic(selectedStablishment);
        }

        if (!isFetchedInquiry && filters.includes(customFilter.tipoInquerito)) {
            loadInquiry();
        }

        // if (filters.includes(customFilter.cliente)) {
        //     loadClientes("", "");
        // }

        if (filters.includes(customFilter.grupoCliente)) {
            form.setFields({
                grupo_cliente: "",
            });
            //     loadClientGroups("", "");
        }
    };

    return (
        <>
            <PageHeader title="Dashboard"></PageHeader>
            <Form layout="vertical">
                <Row gutter={16}>
                    <Col xs={24} md={6}>
                        <Form.Item label="Dashboard">
                            {getFieldDecorator("dashboard", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório!",
                                    },
                                ],
                            })(
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Selecione o dashboard"
                                    optionFilterProp="children"
                                    // filterOption={(input, option) => {
                                    //         return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    // }

                                    // }
                                    style={{ width: "100%" }}
                                    onChange={handleChangeDashboard}
                                >
                                    <OptGroup label="Social">
                                        {dashboardSocial.map((item, index) => (
                                            <Option value={item.key} key={"scl_dashboard-" + index}>
                                                {item.title}
                                            </Option>
                                        ))}
                                    </OptGroup>
                                    <OptGroup label="SGQ">
                                        {dashboardSGQ.map((item, index) => (
                                            <Option value={item.key} key={"sgq_dashboard-" + index}>
                                                {item.title}
                                            </Option>
                                        ))}
                                    </OptGroup>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col md={6}>
                        <Form.Item label="Data">
                            {getFieldDecorator("date")(
                                <RangePicker
                                    format={["DD-MM-YYYY", "DD-MM-YYYY"]}
                                    defaultPickerValue={[null, moment()]}
                                />
                            )}
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={6}>
                        <Form.Item label="Estabelecimento">
                            {getFieldDecorator("stablishment")(
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Selecione o estabelecimento"
                                    loading={loadingStablishment}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: "100%" }}
                                    onChange={(e) => handleChangeStablishment(e)}
                                >
                                    {establishmentList.map((item) => (
                                        <Option
                                            title={item.nome}
                                            value={item.id_estabelecimento}
                                            key={"stablishment-" + item.id_estabelecimento}
                                        >
                                            {item.nome}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    {filterDashboard.includes(customFilter.unidadeOrganica) && (
                        <Col xs={24} md={6}>
                            <Form.Item label="Unidade orgânica">
                                {getFieldDecorator("organicUnit")(
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="Selecione a unidade orgânica"
                                        optionFilterProp="children"
                                        loading={loadingOrganic}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        style={{ width: "100%" }}
                                        onChange={(e) => handleChangeOrganitUnit(e)}
                                    >
                                        {!loadingOrganic &&
                                            Array.isArray(organicUnits) &&
                                            organicUnits.map((item) => (
                                                <Option
                                                    value={item.id_tipo_valencia}
                                                    key={"organicUni-" + item.id_tipo_valencia}
                                                >
                                                    {item.designacao}
                                                </Option>
                                            ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}

                    {filterDashboard.includes(customFilter.sexo) && (
                        <Col xs={24} md={6}>
                            <Form.Item label="Sexo">
                                {getFieldDecorator("sexo")(
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="Selecione sexo"
                                        optionFilterProp="children"
                                        loading={loadingOrganic}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        style={{ width: "100%" }}
                                        onChange={(e) => handleChangeOrganitUnit(e)}
                                    >
                                        {["Masculino", "Feminino", "Não definido"].map((item) => (
                                            <Option value={item} key={"sexo-" + item}>
                                                {item}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}

                    {filterDashboard.includes(customFilter.tipoInquerito) && (
                        <Col md={6}>
                            <Form.Item label="Tipo inquérito">
                                {getFieldDecorator("tipo_inquerito")(
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="Selecione uma opção"
                                        loading={loadingInquiry}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        style={{ width: "100%" }}
                                    >
                                        {inqueritoList.map((item) => (
                                            <Option value={item.valor} key={"inquerito " + item.valor}>
                                                {item.valor}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}

                    {filterDashboard.includes(customFilter.grupoCliente) && (
                        <Col md={6}>
                            <Form.Item label="Grupo de clientes">
                                {getFieldDecorator("grupo_cliente")(
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="Selecione uma opção"
                                        loading={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            String(option.props.children)
                                                ?.toLowerCase()
                                                ?.indexOf(input.toLowerCase()) >= 0
                                        }
                                        style={{ width: "100%" }}
                                        onChange={(value) => handleChangeClientGroups(value)}
                                    >
                                        {clientGroups.map((item) => (
                                            <Select.Option value={item.id_parametro} key={item.id_parametro}>
                                                {item.valor}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}

                    {filterDashboard.includes(customFilter.cliente) && (
                        <Col md={6}>
                            <Form.Item label="Cliente">
                                {getFieldDecorator("cliente")(
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="Selecione uma opção"
                                        loading={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            String(option.props.children)
                                                ?.toLowerCase()
                                                ?.indexOf(input.toLowerCase()) >= 0
                                        }
                                        style={{ width: "100%" }}
                                    >
                                        {clients.map((item) => (
                                            <Select.Option value={item.id_parametro} key={item.id_parametro}>
                                                {item.valor}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}

                    <ApplyDashboardFilter
                        getFieldDecorator={getFieldDecorator}
                        selectedDashboardKey={selectedDashboard?.key}
                    />

                    <Col xs={24} md={6}>
                        <Form.Item label="&nbsp;">
                            <Button type="primary" loading={loadingData} onClick={search}>
                                Consultar
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <br />
            <Spin spinning={loadingData}>
                <RenderDahsboard metadata={dataDashboard.metadata} dataSource={dataDashboard.data} />
            </Spin>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            // selectEstabeleciment,
            selectFixeList,
            // selectOrganic,
            getData: actionCreators.getDataDashboard,
        },
        dispatch
    );
};

const mapStateToProps = (state) => {
    const fixedList = state.fixedList.domain.byId;
    return {
        // stablishmentList: fixedList.estabelecimento ? fixedList.estabelecimento.data : [],
        // organicUnitList: fixedList.unidade_organica ? fixedList.unidade_organica.data : [],
        // macroProcessoList: fixedList.macro_processo ? fixedList.macro_processo.data : [],
        inqueritoList: fixedList.rel_lista_tipo_inquerito ? fixedList.rel_lista_tipo_inquerito.data : [],
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({})(DashboardIndex));
